var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClogo8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 40,
    viewBox: "0 0 64 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_958_9979)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_958_9979)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_958_9979)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2686 14.5871C18.3202 14.5871 19.7584 15.1509 21.9681 17.3706L33.824 29.2801C34.1747 29.6325 34.2448 29.7732 34.3149 29.9847C34.3501 30.0551 34.3501 30.1609 34.3501 30.2314C34.3501 30.3019 34.3501 30.4075 34.3149 30.478C34.2448 30.6894 34.1747 30.8304 33.824 31.1827L25.7213 39.3572C25.3707 39.7095 25.2302 39.78 25.0198 39.8505C24.9497 39.8856 24.8444 39.8856 24.7743 39.8856C24.7042 39.8856 24.5989 39.8856 24.5288 39.8505C24.3184 39.78 24.1779 39.7095 23.8273 39.3572L0.852243 16.2784C0.185933 15.6089 0.43147 14.5871 1.55388 14.5871H15.2686ZM48.7313 0.035151C45.6798 0.035151 44.2415 0.598952 42.0319 2.81883L30.176 14.7281C29.8253 15.0805 29.7552 15.2214 29.6849 15.4328C29.6499 15.5033 29.6499 15.6089 29.6499 15.6794C29.6499 15.7499 29.6499 15.8557 29.6849 15.9262C29.7552 16.1374 29.8253 16.2785 30.176 16.6309L38.2787 24.77C38.6293 25.1224 38.7698 25.1929 38.9801 25.2633C39.0503 25.2985 39.1556 25.2985 39.2257 25.2985C39.2958 25.2985 39.4011 25.2985 39.4712 25.2633C39.6816 25.1929 39.822 25.1224 40.1727 24.77L63.1477 1.69123C63.8141 1.0218 63.5685 0 62.4461 0H48.7313V0.035151Z",
    fill: "#08CF65"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_958_9979"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.0293,
    height: 40,
    fill: "white",
    transform: "translate(0.485352)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_958_9979"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.0293,
    height: 40,
    fill: "white",
    transform: "translate(0.485352)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_958_9979"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.0293,
    height: 39.9994,
    fill: "white",
    transform: "translate(0.485352)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClogo8);
export default __webpack_public_path__ + "static/media/clogo8.2e5072821a02806dacf0db2b6dab4f48.svg";
export { ForwardRef as ReactComponent };